type DynamicComponentKey = 'header' | 'footer' | 'hero';

const getHtml = (key: DynamicComponentKey) => {
    return document.getElementById(`ch-${key}`)?.innerHTML || null;
};

export const header = getHtml('header');
export const footer = getHtml('footer');
export const hero = getHtml('hero');

export {};
